import { backgroundsData } from "../../SharedData";

export const createSpellBookStyles = (theme) => ({
  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    zIndex: 1,
    color: theme.textSecondary,
  },
  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    paddingRight: "44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "16px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "border-color 0.2s ease",
    fontFamily: "inherit",
  },
  searchClearButton: {
    position: "absolute",
    right: "12px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    color: theme.textSecondary,
  },
  searchSection: {
    padding: "16px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.background,
  },
  searchControls: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "12px",
  },
  filterControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  filterIcon: {
    color: theme.textSecondary,
  },
  filterSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "14px",
    fontFamily: "inherit",
  },
  searchResultsInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  searchResultsText: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  clearSearchButton: {
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontFamily: "inherit",
  },
  searchResultsContainer: {
    backgroundColor: theme.surface,
    width: "100%",
    padding: "0",
    boxSizing: "border-box",
  },
  noResultsContainer: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
  },
  noResultsIcon: {
    marginBottom: "16px",
    opacity: 0.5,
  },
  noResultsTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
    margin: "0 0 8px 0",
  },
  noResultsMessage: {
    fontSize: "16px",
    color: theme.textSecondary,
    marginBottom: "20px",
    lineHeight: "1.5",
    margin: "0 0 20px 0",
  },
  subjectCard: {
    backgroundColor: theme.surface,
    borderRadius: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
    transition: "all 0.2s ease",
  },
  subjectHeader: {
    padding: "20px",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  subjectTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "8px",
  },
  subjectTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: 0,
    color: theme.text,
  },
  subjectDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "16px",
    margin: "0 0 16px 0",
  },
  subjectStats: {
    display: "flex",
    gap: "24px",
  },
  subjectStatItem: {
    textAlign: "center",
  },
  subjectStatNumber: {
    display: "block",
    fontSize: "24px",
    fontWeight: "bold",
  },
  subjectStatLabel: {
    display: "block",
    fontSize: "12px",
    color: theme.textSecondary,
    textTransform: "uppercase",
    marginTop: "4px",
  },
  subjectContent: {
    backgroundColor: theme.background,
  },

  sectionContainer: {
    margin: "0",
  },
  sectionButton: {
    width: "100%",
    padding: "16px 20px",
    border: `2px solid transparent`,
    borderRadius: "0",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "inherit",
  },
  sectionLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  sectionRight: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  sectionProgressText: {
    fontSize: "14px",
    fontWeight: "500",
  },
  sectionProgress: {
    width: "100px",
    height: "6px",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    borderRadius: "3px",
    overflow: "hidden",
  },
  sectionProgressFill: {
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: "3px",
    transition: "width 0.3s ease",
  },
  table: {
    width: "100%",
    backgroundColor: theme.surface,
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: theme.background,
  },
  tableHeaderCell: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
  },
  tableHeaderCellCenter: {
    padding: "12px 16px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
  },
  tableRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  tableRowMastered: {
    backgroundColor: (theme.success || "#10b981") + "10",
  },
  tableRowAttempted: {
    backgroundColor: theme.background,
  },
  tableCell: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    verticalAlign: "top",
  },
  tableCellMenu: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    textAlign: "center",
    position: "relative",
  },
  spellNameContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  spellNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  spellName: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  spellNameMastered: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success || "#059669",
  },
  levelBadge: {
    fontSize: "12px",
    padding: "2px 6px",
    backgroundColor: theme.background,
    color: theme.text,
    borderRadius: "4px",
    fontWeight: "500",
  },
  descriptionToggleButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    color: theme.textSecondary,
  },

  criticalMasteredBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: theme.warning || "#fbbf24",
    color: theme.surface,
    border: "none",
  },
  masteredBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: theme.success || "#10b981",
    color: "white",
    border: "none",
  },
  attemptedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    alignSelf: "flex-start",
    backgroundColor: "white",
    color: theme.success || "#10b981",
    border: `2px solid ${theme.success || "#10b981"}`,
  },

  attemptsContainer: {
    display: "flex",
    gap: "12px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
  },
  checkboxFirst: {
    width: "16px",
    height: "16px",
    accentColor: theme.primary || "#3b82f6",
    cursor: "not-allowed",
    opacity: 0.8,
  },
  checkboxSecond: {
    width: "16px",
    height: "16px",
    accentColor: theme.success || "#10b981",
    cursor: "not-allowed",
    opacity: 0.8,
  },
  checkboxText: {
    fontSize: "12px",
    fontWeight: "500",
  },

  criticalSuccessContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
  criticalSuccessText: {
    fontSize: "12px",
    color: theme.warning || "#ffd700",
    fontWeight: "bold",
  },
  noCriticalText: {
    color: theme.textSecondary,
  },

  attemptButton: {
    backgroundColor: theme.primary || "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
  attemptButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },
  menuButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.textSecondary,
  },

  dropdownMenu: {
    position: "absolute",
    right: "0",
    top: "100%",
    backgroundColor: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    minWidth: "160px",
    padding: "4px",
  },
  dropdownMenuItem: {
    width: "100%",
    padding: "8px 12px",
    border: "none",
    background: "none",
    cursor: "pointer",
    textAlign: "left",
    borderRadius: "4px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.text,
    fontFamily: "inherit",
    transition: "background-color 0.2s ease",
  },

  modalOverlay: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modalContent: {
    backgroundColor: theme.background,
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    minWidth: "400px",
    maxWidth: "500px",
  },
  modalTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  modalSubtitle: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  modalCloseButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  modalBody: {
    padding: "0",
  },
  modalDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "20px",
    lineHeight: "1.5",
  },
  alternateButtonsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "12px",
  },
  alternateButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "14px",
    fontFamily: "inherit",
  },
  alternateButtonContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    flex: 1,
  },
  alternateButtonTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
  },
  alternateButtonSubtitle: {
    fontSize: "12px",
    color: theme.textSecondary,
  },
  alternateButtonModifier: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.success || "#10b981",
  },
  descriptionRowCell: {
    padding: "0",
    border: "none",
  },
  descriptionContainer: {
    margin: "0 16px 12px 16px",
    padding: "16px",
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  descriptionTitle: {
    fontWeight: "600",
    color: theme.primary || "#60a5fa",
    marginBottom: "8px",
    fontSize: "16px",
  },
  descriptionMeta: {
    fontStyle: "italic",
    color: theme.textSecondary,
    marginBottom: "12px",
    fontSize: "13px",
  },
  descriptionText: {
    whiteSpace: "pre-line",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },
  descriptionHigherLevels: {
    marginBottom: "12px",
    fontStyle: "italic",
    color: theme.textSecondary,
    margin: "0 0 12px 0",
  },
  descriptionTags: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  descriptionTag: {
    display: "inline-block",
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    fontSize: "12px",
    borderRadius: "4px",
    fontWeight: "500",
    border: `1px solid ${theme.border}`,
  },

  searchResultsHint: {
    color: theme.textSecondary,
    opacity: 0.8,
    marginTop: "8px",
  },
  searchResults: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontStyle: "italic",
    marginTop: "8px",
  },
  searchSuggestions: {
    textAlign: "left",
    display: "inline-block",
    margin: "0 0 24px 0",
    padding: "0",
    listStyle: "none",
  },
  searchContainer: {
    margin: "0 20px 24px 20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  statsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    margin: "0 20px 24px 20px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    flexWrap: "wrap",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  statDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
  },
  subjectsGrid: {
    display: "grid",
    gap: "20px",
    margin: "0 20px",
  },

  researchButton: {
    backgroundColor: "#8b4513",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },

  researchButtonDisabled: {
    backgroundColor: theme.textSecondary,
    cursor: "not-allowed",
  },

  failedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    backgroundColor: theme.error || "#ef4444",
    color: "white",
  },

  researchedBadge: {
    fontSize: "10px",
    fontWeight: "600",
    padding: "2px 6px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    backgroundColor: "#8b4513",
    color: "white",
  },
  tableRowResearched: {
    backgroundColor: "#8b451310",
    borderLeft: `3px solid #8b4513`,
  },
  tableRowFailed: {
    backgroundColor: (theme.error || "#ef4444") + "05",
    borderLeft: `3px solid ${theme.error || "#ef4444"}`,
  },
  modalField: {
    marginBottom: "16px",
    backgroundColor: theme.surface,
  },
  modalLabel: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  },
  modalInput: {
    width: "100%",
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  modalInputDisabled: {
    backgroundColor: theme.background,
    cursor: "not-allowed",
  },
  modalCheckboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    color: theme.text,
  },

  modalCheckbox: {
    width: "16px",
    height: "16px",
  },

  modalCheckboxText: {
    fontSize: "14px",
    fontWeight: "500",
  },

  modalHelpText: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
  },

  modalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "24px",
  },

  modalCancelButton: {
    padding: "8px 16px",
    border: `2px solid ${theme.border}`,
    backgroundColor: theme.surface,
    color: theme.text,
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },

  modalSaveButton: {
    padding: "8px 16px",
    border: `2px solid ${theme.success || "#10b981"}`,
    backgroundColor: theme.success || "#10b981",
    color: "white",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "inherit",
  },

  spellStateIndicators: {
    display: "flex",
    gap: "4px",
    flexWrap: "wrap",
    marginTop: "4px",
  },

  dropdownMenuItemResearch: {
    width: "100%",
    padding: "8px 12px",
    border: "none",
    background: "none",
    cursor: "pointer",
    textAlign: "left",
    borderRadius: "4px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#8b4513",
    fontFamily: "inherit",
    transition: "background-color 0.2s ease",
  },

  searchHighlight: {
    backgroundColor: "#8b451340",
    color: "#8b4513",
    fontWeight: "bold",
    padding: "1px 2px",
    borderRadius: "2px",
  },
});

export const searchStyles = (theme) => ({
  searchContainer: {
    margin: "0 20px 24px 20px",
    padding: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },

  searchInputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },

  searchIcon: {
    position: "absolute",
    left: "12px",
    zIndex: 1,
    pointerEvents: "none",
  },

  searchInput: {
    width: "100%",
    padding: "12px 12px 12px 44px",
    paddingRight: "44px",
    fontSize: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
  searchClearButton: {
    position: "absolute",
    right: "8px",
    padding: "4px",
    border: "none",
    background: "none",
    cursor: "pointer",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
  },
  searchResults: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontStyle: "italic",
    marginTop: "8px",
  },
  searchResultsHint: {
    color: theme.textSecondary,
    opacity: 0.8,
  },
  noResultsContainer: {
    textAlign: "center",
    padding: "60px 20px",
    margin: "20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  noResultsIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    opacity: 0.5,
  },

  noResultsTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },

  noResultsMessage: {
    fontSize: "16px",
    color: theme.textSecondary,
    marginBottom: "20px",
    lineHeight: "1.5",
  },

  searchSuggestions: {
    textAlign: "left",
    display: "inline-block",
    margin: "0 0 24px 0",
    padding: "0",
    listStyle: "none",
  },

  clearSearchButton: {
    padding: "12px 24px",
    backgroundColor: theme.primary,
    color: theme.surface,
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
});

// Helper function for backward compatibility
export const getSpellBookStyles = (theme) => createSpellBookStyles(theme);
export const getSearchStyles = (theme) => searchStyles(theme);
